/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { EVACDeviceFormData } from "../../../../../components/devices/lct/types/providerTypes"
import {
    TAmendEvacDevicePostBody,
    TPublishEvacDevicePostBody,
} from "../../../types/devices/lct/publishEvacDeviceTypes"

export const LCT_YES = "Yes"
export const LCT_NO = "No"

export const booleanToYesNo = (value: boolean): "Yes" | "No" =>
    value ? LCT_YES : LCT_NO

const parseOptionalNumberField = (
    field: number | "" | null
): number | undefined => {
    if (field === "" || field === null) {
        return undefined
    }

    return field
}

/**
 * Generates create EVAC post body from form data
 * @param {EVACDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TPublishEvacDevicePostBody} - the post body for the publish LCT device request
 */
export const createEvacPostBodyFormData = (
    formData: EVACDeviceFormData,
    attachmentUUID: string,
    systemReference?: string
): TPublishEvacDevicePostBody => ({
    device_type: "EVAC",
    device_data: {
        ManufacturerID: formData.manufacturerId?.toString() ?? undefined,
        Make: formData.deviceMake,
        Model: formData.deviceModel,
        ModelReference: formData.deviceModelRef,
        BarcodeNumber: formData.barcodeNumber,
        Phases: formData.phases! as number,
        Voltage: formData.voltage! as number,
        MaxCurrentAmpPerPhase: formData.maxCurrentAmpPerPhase! as number,
        ACOnlyOutput: booleanToYesNo(!!formData.acOnlyOutput),
        V2G_Capability: booleanToYesNo(!!formData.v2gCapability),
        V2G_ExportCapacity: parseOptionalNumberField(
            formData.v2gExportCapacity
        ),
        V2G_CompletionDate: undefined,
        V2G_G99GB_G99NI_Both: formData.v2gG99gbG999niBoth ?? undefined,
        V2G_TTRStatus: formData.v2gTtrStatus,
        Comments: formData.comments,
        Attachment_UUID: attachmentUUID,
        SystemReference: systemReference,
    },
})

/**
 * Generates amend EVAC post body from form data
 * @param {EVACDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TAmendEvacDevicePostBody} - the post body for the publish LCT device amendment request
 */
export const amendEvacPostBodyFormData = (
    formData: EVACDeviceFormData,
    attachmentUUID: string,
    systemReference: string
): TAmendEvacDevicePostBody => ({
    device_type: "EVAC",
    device_data: {
        SystemReference: systemReference,
        ManufacturerID: formData.manufacturerId!,
        Make: formData.deviceMake,
        Model: formData.deviceModel,
        ModelReference: formData.deviceModelRef,
        BarcodeNumber: formData.barcodeNumber,
        Phases: formData.phases! as number,
        Voltage: formData.voltage! as number,
        MaxCurrentAmpPerPhase: formData.maxCurrentAmpPerPhase! as number,
        ACOnlyOutput: booleanToYesNo(!!formData.acOnlyOutput),
        V2G_Capability: booleanToYesNo(!!formData.v2gCapability),
        V2G_ExportCapacity: formData.v2gExportCapacity! as number,
        V2G_CompletionDate: undefined,
        V2G_G99GB_G99NI_Both: formData.v2gG99gbG999niBoth!,
        V2G_TTRStatus: formData.v2gTtrStatus,
        Comments: formData.comments,
        Attachment_UUID: attachmentUUID,
    },
})
